import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { MasterService } from '../../base-classes/master-service';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  private masterService: MasterService<any>;

  constructor(private router: Router, private http: HttpClient) {
    this.masterService = new MasterService<any>(this.http, '');
  }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const token = localStorage.getItem('authToken');
    
    if (!token) {
      // No token, redirect to login
      this.router.navigate(['/auth/login']);
      return false;
    }
    // const requiredModule = route.data['subject'];
    // if (!this.masterService.hasModuleAccess(requiredModule)) {
    //   this.router.navigate(['/unauthorized']);
    //   return false;
    // }
    return true;
  }
}